(function () {
  'use strict';

  var section = document.querySelector('[data-estimator]');
  if (!section) return;

  var amountInput = section.querySelector('[data-estimator-amount]');
  var amountOutput = section.querySelector('[data-estimator-amount-output]');
  var termInput = section.querySelector('[data-estimator-term]');
  var termOutput = section.querySelector('[data-estimator-term-output]');
  var purposeSelect = section.querySelector('[data-estimator-purpose]');
  var resultEl = section.querySelector('[data-estimator-result]');

  // Purely illustrative rate bands per purpose — not a real underwriting model,
  // not tied to any actual provider. Used only to make the slider feel responsive.
  var illustrativeRateByPurpose = {
    personal: 0.11,
    debt: 0.10,
    home: 0.09,
    auto: 0.08,
    business: 0.12,
    emergency: 0.13
  };

  function formatCurrency(value) {
    return '$' + Math.round(value).toLocaleString('en-US');
  }

  function calculate() {
    var amount = parseFloat(amountInput.value) || 0;
    var termMonths = parseFloat(termInput.value) || 1;
    var purpose = purposeSelect.value;
    var annualRate = illustrativeRateByPurpose[purpose] || 0.11;
    var monthlyRate = annualRate / 12;

    // Standard amortized monthly payment formula — illustrative only.
    var monthlyPayment;
    if (monthlyRate === 0) {
      monthlyPayment = amount / termMonths;
    } else {
      var factor = Math.pow(1 + monthlyRate, termMonths);
      monthlyPayment = (amount * monthlyRate * factor) / (factor - 1);
    }

    if (amountOutput) amountOutput.textContent = formatCurrency(amount);
    if (termOutput) termOutput.textContent = termMonths + ' months';
    if (resultEl) {
      resultEl.textContent = formatCurrency(monthlyPayment) + ' /mo';
      resultEl.classList.remove('is-updated');
      // Force reflow so the snappy scale-pulse can re-trigger on every input change.
      void resultEl.offsetWidth;
      resultEl.classList.add('is-updated');
    }
  }

  [amountInput, termInput, purposeSelect].forEach(function (el) {
    if (el) el.addEventListener('input', calculate);
  });

  calculate();
})();
